import { render, staticRenderFns } from "./lylb.vue?vue&type=template&id=2990b75a&scoped=true&"
import script from "./lylb.vue?vue&type=script&lang=js&"
export * from "./lylb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990b75a",
  null
  
)

export default component.exports